<script>
  import { _, theme, language } from "../../stores/index";
  import {
    Button,
    Select,
    SelectItem,
    RadioGroup,
    RadioGroupItem,
  } from "@gl/design-system";
  import darkModeImg from "../../assets/DarkModeImage.png";
  import lightModeImg from "../../assets/LightModeImage.png";
  import { locale } from "svelte-i18n";
  import { onMount } from "svelte";

  let form = {};

  function handleLanguage() {
    locale.set(form.language);
    language.set(form.language);
    document.documentElement.lang = form.language;
  }

  function handleChange() {
    handleLanguage($language);
    theme.set(form.theme);
  }

  onMount(() => {
    if ($language) form.language = $language;
    if ($theme) form.theme = $theme;
  });
</script>

<svelte:head>
  <title>
    {$_("users.me.profile")} | {$_("access-manager")}
  </title>
</svelte:head>

<div class="main">
  <div class="preferences">
    <div class="user-main-card w-100">
      <div class="user-row" id="user-theme">
        <div class="user-title">
          <p>{$_("common.theme")}</p>
        </div>

        <div class="user-td">
          <RadioGroup bind:value={form.theme}>
            <RadioGroupItem value="light" label={$_("common.light")} />
            <img src={lightModeImg} alt="light-mode-img" class="mr-4" />

            <RadioGroupItem value="dark" label={$_("common.dark")} />
            <img src={darkModeImg} alt="dark-mode-img" />
          </RadioGroup>
        </div>
      </div>

      <div class="user-row" id="language">
        <div class="user-title">{$_("common.language")}</div>
        <div class="user-td">
          <Select label="" bind:value={form.language} style="width:100%">
            <SelectItem label="English" value="en" />
            <SelectItem label="Deutsch" value="de" />
          </Select>
        </div>
      </div>
    </div>
  </div>

  <div class="footer mt-3 pt-4">
    <div class="buttons">
      <Button on:click={() => handleChange()} class="mr-2"
        >{$_("common.save")}</Button
      >
      <Button
        outlined
        on:click={() => {
          form.language = "en";
          form.theme = "light";
          handleChange();
        }}>{$_("common.reset")}</Button
      >
    </div>
  </div>
</div>

<style>
  .main {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .preferences {
    flex-grow: 2;
  }

  .footer {
    border-top: 1px solid var(--gl-border);
    flex-grow: 1;
  }

  .buttons {
    display: flex;
    justify-content: end;
  }
</style>
